module.exports = __webpack_public_path__ + "static/media/btt.5a723bab.png";